
const styles = theme => ({
  appBar: {
    position: 'static',
    flexGrow: 1,
    "border-bottom": '5px solid #78BE43 !important'
  },
  faqLink: {
    position: 'absolute',
    right: '24px',
    top: '40px',
    'font-family': 'Verdana',
    'font-size': '10px',
    'text-decoration': 'underline',
    color: '#636363',
    cursor: 'pointer'
  },
  //TODO: get the hover thing working
  'faqLink:hover': {
    color: '#66bd2b'
  },
  headerBtn: {
    maxHeight: '5px', minHeight: '5px',
    "font-size": "10px",
    "font-weight": "bold"
  },
  headerWelcome: {
    color: "#b7b7b7",
    "font-size": "14px"
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + 8 * 2 * 2)]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + 8 * 3 * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: `${theme.spacing(3)} 0 ${theme.spacing(5)}`,
  }
});


export default styles;
